"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const regex_trim_1 = require("../maps/regex_trim");
const regexSplit = (pattern) => (target) => target.split(RegExp(regex_trim_1.default(pattern)));
exports.default = regexSplit;
//# sourceMappingURL=regex_split.js.map